export const RISK_REVIEW_INPUT_TYPES = [
  "TEXT",
  "TEXTAREA",
  "NUMBER",
  "DECIMAL",
  "CURRENCY",
  "PERCENTAGE",
  "DATE",
  "DATETIME",
  "YES_NO",
  "RADIO",
  "CHECKBOX",
  "SELECT",
  "MULTI_SELECT",
  "VALUE_HELP",
  "AUTOCOMPLETE",
  "READ_ONLY",
  "CALCULATED",
  "FILE_UPLOAD",
  "EXCEL_UPLOAD",
  "QUESTION_YES_NO",
  "QUESTION_SELECT",
  "HEADING",
  "INSTRUCTION",
  "SEPARATOR",
];
